import script from "./xuanchuanVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./xuanchuanVideo.vue?vue&type=script&setup=true&lang=js"

import "./xuanchuanVideo.vue?vue&type=style&index=0&id=1fc7db56&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc7db56"]])

export default __exports__